import { Typography, Link, Stack } from '@mui/material';
import { AuthentificationFormsSelectTeam } from '@scorenco/components';
import { RouteLink } from '@scorenco/core';

const AuthentificationSelectTeam = () => {
  return (
    <>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="baseline"
        mb={3}
      >
        <Typography variant="h2" textAlign="left">
          Premier pas
        </Typography>
        <RouteLink href="/auth/select-club">
          <Link variant="body1">Retour</Link>
        </RouteLink>
      </Stack>

      <Stack gap={2} alignItems="stretch">
        <AuthentificationFormsSelectTeam />
      </Stack>
    </>
  );
};

export default AuthentificationSelectTeam;
